import { render } from "./SqlDatabaseConfigurationForm.vue?vue&type=template&id=6088e3ac&ts=true"
import script from "./SqlDatabaseConfigurationForm.vue?vue&type=script&lang=ts"
export * from "./SqlDatabaseConfigurationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__